import * as action from '../actions/actions';

const initialState = {
	loading: true,
	stats: {},
	error: ""
}

const statsReducer = (state = initialState, action) => {
	if(action.type === "APIStats") {
        return { ...state, stats: action.country.data, loading: false, error: false }
	}
	else if (action.type === "APIError") {
		return {...state, error: action.error, loading: false}
	}
	else {
		return state;
	}
}

export default statsReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/statsReducer.js